import { Route } from "@angular/router";
import { HomePageComponent } from "./home-page.component";

export const HomePageRouting: Route = { 
    path: '',
    component: HomePageComponent,
    data: {
        breadcrumb: "Accueil"
    }
};
